import store from '@/stores';
import { MUTATION_NAME, MUTATION_NAMESPACE, ROUTES } from '@/static/global-variables';

const CUSTOM_HEADERS = {
    SIGNATURE_TYPE: "veeva-engage-signature-type"
}

const setSignatureType = responseHeaders => {
    store.commit(MUTATION_NAME.SET_SIGNATURE_TYPE, responseHeaders[CUSTOM_HEADERS.SIGNATURE_TYPE]);
};

const setData = {
    setSamples: (response, responseHeaders) => {
        if(response.bannerUrl) {
            store.commit(MUTATION_NAME.SET_BANNER_URL, response.bannerUrl)
        }
        store.commit(MUTATION_NAME.SET_SIGNEE, response.signee);
        store.commit(MUTATION_NAME.SET_DETAILED_PRODUCTS, response.detailedProducts);
        store.commit(MUTATION_NAME.SET_ADDRESS, response.address);
        store.commit(MUTATION_NAME.SET_SAMPLES, response.samples);
        store.commit(MUTATION_NAME.SET_LICENSE, response.license);
        store.commit(MUTATION_NAME.SET_DEA, response.dea);
        store.commit(MUTATION_NAME.SET_SHIP_TO_LICENSE, response.shipToLicense);
        store.commit(MUTATION_NAME.SET_SHIP_TO_DEA, response.shipToDea);
        store.commit(MUTATION_NAME.SET_SHIP_TO_ADDRESS, response.shipToAddress);
        store.commit(MUTATION_NAME.SET_DISCLAIMER, response.disclaimer);
        store.commit(MUTATION_NAME.SET_MESSAGE_INVALID_SIGNATURE, response.messageInvalidSignature);
        store.commit(MUTATION_NAME.SET_ROUTE, ROUTES.SAMPLES);
        setSignatureType(responseHeaders);
    },
    setInquiries: (response, responseHeaders) => {
        if(response.bannerUrl) {
            store.commit(MUTATION_NAME.SET_BANNER_URL, response.bannerUrl)
        }
        store.commit(MUTATION_NAME.SET_SIGNEE, response.signee);
        store.commit(MUTATION_NAME.SET_DISCLAIMER, response.disclaimer);
        store.commit(MUTATION_NAME.SET_MESSAGE_INVALID_SIGNATURE, response.messageInvalidSignature);
        store.commit(MUTATION_NAME.SET_INQUIRIES, response.inquiries);
        store.commit(MUTATION_NAME.SET_ROUTE, ROUTES.INQUIRIES);
        store.commit(MUTATION_NAME.SET_LOCATION, response.location);
        setSignatureType(responseHeaders);
    },
    setOptIn: (response, responseHeaders) => {
        if(response.bannerUrl) {
            store.commit(MUTATION_NAME.SET_BANNER_URL, response.bannerUrl)
        }
        store.commit(MUTATION_NAME.SET_SIGNEE, response.signee);
        store.commit(MUTATION_NAME.SET_LICENSE, response.license);
        store.commit(MUTATION_NAME.SET_DISCLAIMER, response.disclaimer);
        store.commit(MUTATION_NAME.SET_MESSAGE_INVALID_SIGNATURE, response.messageInvalidSignature);
        store.commit(MUTATION_NAME.SET_CONSENT, response.consent);
        store.commit(MUTATION_NAME.SET_ROUTE, ROUTES.SAMPLE_OPT_IN);
        setSignatureType(responseHeaders);
    },
    setAoC: (data, responseHeaders) => {
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_CONTENT_ACKNOWLEDGEMENT_ITEMS}`, data.contentAcknowledgementItems);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_TO_ADDRESS}`, data?.contentAcknowledgement?.shipAddress);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_TO_LOCATION}`, data?.contentAcknowledgement?.shipLocation);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_DELIVERY_DATE}`, data?.contentAcknowledgement?.deliveryDate);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_DATE}`, data?.contentAcknowledgement?.shipDate);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_ORDER_ID}`, data?.contentAcknowledgement?.orderId);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_TO_LICENSE}`, data?.contentAcknowledgement?.shipLicense);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_TO_DEA}`, data?.contentAcknowledgement?.shipDEA);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_CDS}`, data?.contentAcknowledgement?.shipCDS);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SHIP_STATE_DISTRIBUTOR}`, data?.contentAcknowledgement?.shipStateDistributor);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_DISCLAIMER}`, data?.contentAcknowledgement?.disclaimer);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_RECEIVED_BY}`, data?.contentAcknowledgement?.receivedBy);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_RECEIVED_BY_FIRST_NAME}`, data?.contentAcknowledgement?.receivedByFirstName);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_RECEIVED_BY_MIDDLE_NAME}`, data?.contentAcknowledgement?.receivedByMiddleName);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_RECEIVED_BY_LAST_NAME}`, data?.contentAcknowledgement?.receivedByLastName);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_RECEIVED_TITLE}`, data?.contentAcknowledgement?.receivedTitle);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_ACCOUNT_FIRST_NAME}`, data?.targetAccount?.firstName);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_ACCOUNT_MIDDLE_NAME}`, data?.targetAccount?.middleName);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_ACCOUNT_LAST_NAME}`, data?.targetAccount?.lastName);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_ACCOUNT_CREDENTIALS}`, data?.targetAccount?.credentials);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_BANNER_URL}`, data?.bannerUrl);
        store.commit(`${MUTATION_NAMESPACE.AOC}/${MUTATION_NAME.SET_SIGNEE}`, data?.signee);
        store.commit(`${MUTATION_NAMESPACE.MESSAGE}/${MUTATION_NAME.SET_VEEVA_MESSAGE}`, data.veevaMessage);
        setSignatureType(responseHeaders);
    }
}

export default setData;
